import React from "react";
import MICEFieldsSection from "./MICEFieldsSection";

const LocalAttendeesView = () => {
  const convertOptions = (options = []) => {
    let _options = [];
    options.forEach((option) => {
      _options.push({ value: option, label: option });
    });
    return _options;
  };
  return (
    <>
      <MICEFieldsSection
        formFields={[
          { type: "default", label: "Event Name", name: "eventName" },
          { type: "default", label: "Client/Organizer", name: "clientName" },
          { type: "numeric", label: "Number of Hrs", name: "numberHrs" },
          {
            type: "dropdown",
            label: "Classifications",
            name: "classification",
            options: convertOptions([
              "Local",
              "Regional",
              "National",
              "International",
            ]),
          },
          {
            type: "dropdown",
            label: "Type of Event",
            name: "eventType",
            options: convertOptions([
              "Meetings",
              "Incentives",
              "Conventions",
              "Exhibitions",
              "Others",
            ]),
          },
          { type: "dual", label: "If Exhibitions", name: "exhibitions" },
          { type: "default", label: "Remarks", name: "remarks" },
        ]}
        rowFields={[
          { label: "Male", name: "male" },
          { label: "Female", name: "female" },
        ]}
      />
    </>
  );
};

export default LocalAttendeesView;
